import { createReducer, createAction } from 'redux-act';
import toast from 'shared/utils/toast';

import {
  fetchData,
  createData,
  deleteDataById,
  updateDataById
} from 'services/integratedShipping/truckAssignmentSetup';

const initialState = {
  isFetching: true,
  data: [],
  isUpdate: false,
  error: false,
  message: ''
};

const fetchDataActionStart = createAction(
  'start fetch truck assignment setup list'
);
const fetchDataActionSuccess = createAction(
  'fetch truck assignment setup list success'
);
const fetchDataActionError = createAction(
  'fetch truck assignment setup list error'
);

const createUpdateDataActionStart = createAction(
  'start create/update truck assignment setup'
);
const createUpdateDataActionSucess = createAction(
  'create/update truck assignment setup success'
);
const createUpdateDataActionError = createAction(
  'create/update truck assignment setup error'
);

export default createReducer(
  {
    [fetchDataActionStart]: (state) => ({
      ...state,
      isFetching: true
    }),
    [fetchDataActionSuccess]: (state, payload) => ({
      ...state,
      isFetching: false,
      data: payload.data
    }),
    [fetchDataActionError]: (state) => ({
      ...state,
      isFetching: false,
      error: true,
      message: 'Have some errors while fetch data'
    }),
    [createUpdateDataActionStart]: (state) => ({
      ...state,
      isUpdate: true
    }),
    [createUpdateDataActionSucess]: (state) => ({
      ...state,
      isUpdate: false
    }),
    [createUpdateDataActionError]: (state) => ({
      ...state,
      isUpdate: false
    })
  },
  initialState
);

export const fetchTruckAssignmentSetupList = (companyId, filter) => {
  return async (dispatch) => {
    try {
      dispatch(fetchDataActionStart());
      const res = await fetchData(companyId, filter);
      dispatch(fetchDataActionSuccess({ data: res.data }));
    } catch (e) {
      dispatch(fetchDataActionError());
    }
  };
};

export const createTruckAssignmentSetupAction = (companyId, data) => {
  return async (dispatch) => {
    try {
      const res = await createData(companyId, data);
      if (res) {
        dispatch(createUpdateDataActionSucess());
        toast.success('Truck Assignment Setup has been created');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error('Error occurred when creating Truck Assignment Setup');
    }
  };
};

export const updateTruckAssignmentSetupAction = (id, companyId, data) => {
  return async (dispatch) => {
    try {
      const res = await updateDataById(id, companyId, data);
      if (res) {
        dispatch(createUpdateDataActionSucess());
        toast.success('Truck Assignment Setup has been updated');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error('Error occurred when updating Truck Assignment Setup');
    }
  };
};

export const deleteTruckAssignmentSetupAction = (id) => {
  return async (dispatch) => {
    try {
      const res = await deleteDataById(id);
      if (res) {
        dispatch(createUpdateDataActionSucess());
        toast.success('Truck Assignment Setup has been deleted');
      }
    } catch (e) {
      dispatch(createUpdateDataActionError());
      toast.error('Error occurred when deleting Truck Assignment Setup');
    }
  };
};
